import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import ProgressBar from "../../components/ProgressBarWithBackArrow/ProgressBarWithBackArrow";
import "../SignupPages/SignupCommon.css";


const NadPlusPage1: React.FC = () => {
  const [gender, setGender] = useState<string>("");
  const [isPlanningBaby, setIsPlanningBaby] = useState<string>("");
  const navigate = useNavigate();
  const location = window.location.pathname;
  const isSermorelinPage = location.includes("sermorelin");

  const handleGenderOptionClick = (option: string) => {
    setGender(option);
    if (option === "Male") {
      setIsPlanningBaby("");
    }
  };



  const handleBabyPlanningOptionClick = (option: string) => {
    setIsPlanningBaby(option);
  };

  useEffect(() => {
    const savedGender = localStorage.getItem("gender");
    const savedIsPlanningBaby = localStorage.getItem("isPlanningBaby");

    if (savedGender) {
      const parsedGender = JSON.parse(savedGender);
      setGender(parsedGender.value);
    }

    if (savedIsPlanningBaby) {
      const parsedIsPlanningBaby = JSON.parse(savedIsPlanningBaby);
      setIsPlanningBaby(parsedIsPlanningBaby.value);
    }
  }, []);

  const optionsForBabyPlanning = [
    "None of the Following",
    "Currently or possibly pregnant, or actively trying to become pregnant",
    "Breastfeeding or bottle feeding with breastmilk",
  ];

  const styles = {
    optionsStacked: {
      display: "flex" as const,
      flexDirection: "column" as const,
      gap: "15px",
      marginBottom: "20px",
      width: "100%",
      marginTop: "41px",
    } as React.CSSProperties,
    optionLabel: {
      fontSize: "18px",
      padding: "15px",
      cursor: "pointer",
      border: "1px solid #96C6DA",
      borderRadius: "10px",
      transition: "background-color 0.3s ease",
      width: "100%",
      textAlign: "center",
      backgroundColor: "white",
    },
    optionLabelSelected: {
      backgroundColor: "#0C3972",
      color: "white",
    },
  };

  const handleNext = () => {
    if (gender) {
      localStorage.setItem(
        "gender",
        JSON.stringify({ key: "gender", value: gender })
      );
    }
    if (isPlanningBaby) {
      localStorage.setItem(
        "isPlanningBaby",
        JSON.stringify({
          key: "isPlanningBaby",
          value: isPlanningBaby,
          id: 18026056,
        })
      );
    }

    const isAllowed =
      gender === "Male" ||
      (gender === "Female" && isPlanningBaby === "None of the Following");

    if(isSermorelinPage){
      navigate(isAllowed ? "/sermorelin/getting-started/step-2" : "/sermorelin/disqualified");
    }else{
      navigate(isAllowed ? "/nadplus/getting-started/step-2" : "/nadplus/disqualified");
    }
    localStorage.setItem("completed-step-1", "true");
  };

  const genderOptions = ["Male", "Female"];

  const handleBack = () => {
    if(isSermorelinPage){
      navigate("/sermorelin")
    }else{
      navigate("/nadplus")
    }
    
  }

  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <ProgressBar progress={10} onBack={handleBack}/>
        <div className="signup-content">
          <p className="signup-intro">What is your sex assigned at birth?</p>
          <div className="optionsLeftRight">
            {genderOptions.map((option) => (
              <label
                key={option}
                className={`optionLabel optionLabel-box ${
                  gender === option ? "optionLabelSelected optionLabelSelected-box" : ""
                }`}
                onClick={() => handleGenderOptionClick(option)}
              >
                {option}
              </label>
            ))}
          </div>
          {gender === "Female" && (
            <>
              <p className="signup-question" style={{ marginTop: "72px" }}>
                Are you currently or planning for any of the following?
              </p>
              <div style={styles.optionsStacked}>
                {optionsForBabyPlanning.map((option) => (
                  <label
                    key={option}
                    onClick={() => handleBabyPlanningOptionClick(option)}
                    className={`otherOptionLabel otherOptionLabel-box ${
                      isPlanningBaby === option ? "optionLabelSelected optionLabelSelected-box" : ""
                    }`}
                  >
                    {option}
                  </label>
                ))}
              </div>
            </>
          )}
          <button
            className="next-btn sticky-btn"
            onClick={handleNext}
            disabled={!gender || (gender === "Female" && !isPlanningBaby)}
          >
            Next →
          </button>
        </div>
      </div>
    </PageWrapper>
  );
};

export default NadPlusPage1;
